module.exports = __webpack_public_path__ + "static/media/surface.62627146.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/surface.svg
// module id = 697
// module chunks = 0